// frontend/src/config/api.js
// ⚠️ IMPORTANTE: Este archivo DEBE estar en frontend/src/config/api.js
//
// NOTA SOBRE RUTAS:
// - En DESARROLLO: Frontend llama directo al backend (localhost:5001) SIN /api/
// - En PRODUCCIÓN: Frontend llama a Nginx CON /api/, Nginx quita /api/ y envía al backend

const isDevelopment = process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;

// URL base del backend
export const API_URL = isDevelopment
  ? 'http://localhost:5001'
  : (process.env.REACT_APP_API_URL || 'https://nextunicodecorp.com');

// Prefix para rutas que pasan por /api/ en producción
const API_PREFIX = isDevelopment ? '' : '/api';

export const API_ENDPOINTS = {
  // Auth routes
  login: `${API_URL}${API_PREFIX}/auth/login`,
  register: `${API_URL}${API_PREFIX}/auth/register`,
  registerAdmin: `${API_URL}${API_PREFIX}/auth/register-admin`,
  validateRegistrationToken: `${API_URL}${API_PREFIX}/auth/validate-registration-token`,
  me: `${API_URL}${API_PREFIX}/auth/me`,
  users: `${API_URL}${API_PREFIX}/auth/users`,
  createUser: `${API_URL}${API_PREFIX}/auth/create-user`,

  // 2FA Verification
  verifyCode: `${API_URL}${API_PREFIX}/auth/verify-code`,
  resendCode: `${API_URL}${API_PREFIX}/auth/resend-code`,

  // Billing routes
  billingInfo: `${API_URL}${API_PREFIX}/billing/info`,
  billingHistory: `${API_URL}${API_PREFIX}/billing/history`,
  billingCancel: `${API_URL}${API_PREFIX}/billing/cancel`,

  // Account routes
  accountStatus: `${API_URL}${API_PREFIX}/account/status`,
  accountSuspensionInfo: `${API_URL}${API_PREFIX}/account/suspension-info`,

  // Subscriptions
  subscriptions: `${API_URL}${API_PREFIX}/subscriptions`,
  subscriptionsCreate: `${API_URL}${API_PREFIX}/subscriptions/create`,
  subscriptionsPlans: `${API_URL}${API_PREFIX}/subscriptions/plans`,
  subscriptionsActivate: `${API_URL}${API_PREFIX}/subscriptions/activate`,
  subscriptionsCondominium: (id) => `${API_URL}${API_PREFIX}/subscriptions/condominium/${id}`,
  subscriptionsValidateDiscount: `${API_URL}${API_PREFIX}/subscriptions/validate-discount`,

  // PayPal routes
  paypalValidateDiscount: `${API_URL}${API_PREFIX}/paypal/validate-discount`,
  paypalSubscriptionCapture: `${API_URL}${API_PREFIX}/paypal/subscription/capture`,
  paypalAlicuotaCapture: `${API_URL}${API_PREFIX}/paypal/alicuota/capture`,
  paypalPaymentMethod: `${API_URL}${API_PREFIX}/paypal/payment-method`,
  paypalPaymentMethodUpdate: `${API_URL}${API_PREFIX}/paypal/payment-method/update`,
  paypalPlans: `${API_URL}${API_PREFIX}/paypal/plans`,

  // Support routes
  supportInfo: `${API_URL}${API_PREFIX}/support/system-info`,
  supportTickets: `${API_URL}${API_PREFIX}/support/tickets`,
  supportBackups: `${API_URL}${API_PREFIX}/support/backups`,
  supportBackup: `${API_URL}${API_PREFIX}/support/backup`,
  supportChangePassword: `${API_URL}${API_PREFIX}/support/change-password`,

  // Payment config
  paymentConfigCheck: `${API_URL}${API_PREFIX}/payment-config/check`,
  paymentConfig: `${API_URL}${API_PREFIX}/payment-config`,
  paymentConfigByPayment: (paymentId) => `${API_URL}${API_PREFIX}/payment-config/by-payment/${paymentId}`,

  // Invoices
  invoices: `${API_URL}${API_PREFIX}/invoices`,

  // Contact routes (publicas)
  contactSend: `${API_URL}${API_PREFIX}/contact/send`,

  // Password reset (en raíz con API_PREFIX)
  forgotPassword: `${API_URL}${API_PREFIX}/forgot-password`,
  verifyResetCode: `${API_URL}${API_PREFIX}/verify-reset-code`,
  resetPassword: `${API_URL}${API_PREFIX}/reset-password`,

  // SuperAdmin routes
  superadminCondominiums: `${API_URL}${API_PREFIX}/superadmin/condominiums`,
  superadminSettings: `${API_URL}${API_PREFIX}/superadmin/settings`,
  systemInfo: `${API_URL}${API_PREFIX}/system/info`,
  systemSettings: `${API_URL}${API_PREFIX}/system/settings`,
  systemBackup: `${API_URL}${API_PREFIX}/system/backup`,
  authProfile: `${API_URL}${API_PREFIX}/auth/profile`,
  authChangePassword: `${API_URL}${API_PREFIX}/auth/change-password`,

  // Aliases para UserProfile
  changePassword: `${API_URL}${API_PREFIX}/auth/change-password`,
  updateProfile: `${API_URL}${API_PREFIX}/auth/profile`,

  // PayPal config del condominio
  condominiumPayPalConfig: `${API_URL}${API_PREFIX}/condominiums/paypal-config`,
  condominiumPayPalClientId: `${API_URL}${API_PREFIX}/condominiums/paypal-client-id`,

  // Rutas principales (DEBEN pasar por /api/ en producción)
  payments: `${API_URL}${API_PREFIX}/payments`,
  notices: `${API_URL}${API_PREFIX}/notices`,
  condominiums: `${API_URL}${API_PREFIX}/condominiums`,
  health: `${API_URL}${API_PREFIX}/health`,

  // Endpoints dinámicos para payments
  paymentsById: (id) => `${API_URL}${API_PREFIX}/payments/${id}`,
  paymentsUser: `${API_URL}${API_PREFIX}/payments/user`,
  paymentsSubmitApproval: (id) => `${API_URL}${API_PREFIX}/payments/${id}/submit-for-approval`,
  paymentsStatus: (id) => `${API_URL}${API_PREFIX}/payments/${id}/status`,
  paymentsPaypalComplete: (id) => `${API_URL}${API_PREFIX}/payments/${id}/paypal-complete`,

  // Endpoints dinámicos para notices
  noticesById: (id) => `${API_URL}${API_PREFIX}/notices/${id}`,

  // Chat routes
  chatConversations: `${API_URL}${API_PREFIX}/chat/conversations`,
  chatConversationIndividual: `${API_URL}${API_PREFIX}/chat/conversations/individual`,
  chatConversationGroup: `${API_URL}${API_PREFIX}/chat/conversations/group`,
  chatMessages: (id) => `${API_URL}${API_PREFIX}/chat/conversations/${id}/messages`,
  chatMessagesFile: (id) => `${API_URL}${API_PREFIX}/chat/conversations/${id}/messages/file`,
  chatMarkRead: (id) => `${API_URL}${API_PREFIX}/chat/conversations/${id}/read`,
  chatSearchUsers: `${API_URL}${API_PREFIX}/chat/search/users`,

  // Chat Device Trust (Fase 1 - Seguridad)
  chatDeviceVerify: `${API_URL}${API_PREFIX}/chat/device/verify`,
  chatDeviceTrust: `${API_URL}${API_PREFIX}/chat/device/trust`,
  chatDeviceList: `${API_URL}${API_PREFIX}/chat/device/list`,
  chatDeviceRevokeAll: `${API_URL}${API_PREFIX}/chat/device/all`,
  chatDeviceRevoke: (deviceId) => `${API_URL}${API_PREFIX}/chat/device/${deviceId}`,
  chatDeviceLogAccess: `${API_URL}${API_PREFIX}/chat/device/log-access`,
  chatDeviceTermsStatus: `${API_URL}${API_PREFIX}/chat/device/terms-status`,

  // ═══════════════════════════════════════════════════════════════
  // SuperAdmin routes (Panel Pro)
  // ═══════════════════════════════════════════════════════════════
  superAdminDashboard: `${API_URL}${API_PREFIX}/superadmin/dashboard`,
  superAdminAdministrators: `${API_URL}${API_PREFIX}/superadmin/administrators`,
  superAdminProjects: `${API_URL}${API_PREFIX}/superadmin/projects`,
  superAdminSystemStats: `${API_URL}${API_PREFIX}/superadmin/system-stats`,
  superAdminMetricsHistory: `${API_URL}${API_PREFIX}/superadmin/metrics-history`,
  superAdminBackups: `${API_URL}${API_PREFIX}/superadmin/backups`,
  superAdminBackupDownload: (id) => `${API_URL}${API_PREFIX}/superadmin/backups/${id}/download`,
  superAdminSettings: `${API_URL}${API_PREFIX}/superadmin/settings`,
  superAdminFinancialStats: `${API_URL}${API_PREFIX}/superadmin/financial-stats`,
  superAdminBackupDelete: (filename) => `${API_URL}${API_PREFIX}/superadmin/backups/${filename}`,
  superAdminExportExcel: (type) => `${API_URL}${API_PREFIX}/superadmin/export/${type}`,
  superAdminProjectUsers: (id) => `${API_URL}${API_PREFIX}/superadmin/projects/${id}/users`,

  // ═══════════════════════════════════════════════════════════════
  // UrbanIA - Agente IA Local
  // ═══════════════════════════════════════════════════════════════
  agentChat: `${API_URL}${API_PREFIX}/agent/chat`,

  // ═══════════════════════════════════════════════════════════════
  // UrbanIA - Historial de Conversaciones
  // ═══════════════════════════════════════════════════════════════
  urbaniaConversations: `${API_URL}${API_PREFIX}/agent/history/conversations`,
  urbaniaConversationDelete: (id) => `${API_URL}${API_PREFIX}/agent/history/conversations/${id}`,
  urbaniaMessages: (id) => `${API_URL}${API_PREFIX}/agent/history/conversations/${id}/messages`,
  urbaniaConversationTitle: (id) => `${API_URL}${API_PREFIX}/agent/history/conversations/${id}/title`,
  urbaniaConversationFolder: (id) => `${API_URL}${API_PREFIX}/agent/history/conversations/${id}/folder`,
  urbaniaFolders: `${API_URL}${API_PREFIX}/agent/history/folders`,
  urbaniaFolderDelete: (id) => `${API_URL}${API_PREFIX}/agent/history/folders/${id}`,

  // ═══════════════════════════════════════════════════════════════
  // Sistema Financiero Avanzado v1.9.6
  // ═══════════════════════════════════════════════════════════════
  financialInit: `${API_URL}${API_PREFIX}/financial/init`,
  financialDashboard: `${API_URL}${API_PREFIX}/financial/dashboard`,
  financialIncome: `${API_URL}${API_PREFIX}/financial/income`,
  financialIncomeById: (id) => `${API_URL}${API_PREFIX}/financial/income/${id}`,
  financialExpense: `${API_URL}${API_PREFIX}/financial/expense`,
  financialExpenseById: (id) => `${API_URL}${API_PREFIX}/financial/expense/${id}`,
  financialBudget: `${API_URL}${API_PREFIX}/financial/budget`,
  financialAnnualSummary: `${API_URL}${API_PREFIX}/financial/annual-summary`,
  financialCategories: `${API_URL}${API_PREFIX}/financial/categories`,
  financialCategoriesById: (id) => `${API_URL}${API_PREFIX}/financial/categories/${id}`,
  financialConfig: `${API_URL}${API_PREFIX}/financial/config`,

  // ═══════════════════════════════════════════════════════════════
  // Sistema de Reservas v1.9.7
  // ═══════════════════════════════════════════════════════════════
  reservationAreas: `${API_URL}${API_PREFIX}/reservations/areas`,
  reservations: `${API_URL}${API_PREFIX}/reservations`,
  reservationsUser: `${API_URL}${API_PREFIX}/reservations/user`,
  reservationStats: `${API_URL}${API_PREFIX}/reservations/stats`,
  reservationCalendar: `${API_URL}${API_PREFIX}/reservations/calendar`,
  reservationAvailability: `${API_URL}${API_PREFIX}/reservations/availability`,
  reservationById: (id) => `${API_URL}${API_PREFIX}/reservations/${id}`,
  reservationStatus: (id) => `${API_URL}${API_PREFIX}/reservations/${id}/status`,
  reservationReceipt: (id) => `${API_URL}${API_PREFIX}/reservations/${id}/receipt`,
  reservationSchedule: `${API_URL}${API_PREFIX}/reservations/schedule`,
  reservationAreaReactivate: (id) => `${API_URL}${API_PREFIX}/reservations/areas/${id}/reactivate`,
  reservationAreaPhoto: (id) => `${API_URL}${API_PREFIX}/reservations/areas/${id}/photo`
};

export const apiRequest = async (url, options = {}) => {
  const token = localStorage.getItem('token');
  
  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };

  const config = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers
    }
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      // ═══ Suscripción expirada: redirigir Admin ═══
      if (response.status === 402) {
        const err402 = await response.json().catch(() => ({}));
        console.warn('⚠️ Suscripción expirada:', err402);
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          try {
            const u = JSON.parse(storedUser);
            if (u.role === 'Admin') {
              window.location.href = '/subscription-expired';
              throw new Error('SUBSCRIPTION_EXPIRED');
            }
          } catch (e) {
            if (e.message === 'SUBSCRIPTION_EXPIRED') throw e;
          }
        }
        throw new Error(err402.message || 'Suscripción expirada');
      }

      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error en API request:', error);
    throw error;
  }
};

export const apiRequestFormData = async (url, formData) => {
  const token = localStorage.getItem('token');
  
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      body: formData
    });

    if (!response.ok) {
      // ═══ Suscripción expirada: redirigir Admin ═══
      if (response.status === 402) {
        const err402 = await response.json().catch(() => ({}));
        console.warn('⚠️ Suscripción expirada:', err402);
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
          try {
            const u = JSON.parse(storedUser);
            if (u.role === 'Admin') {
              window.location.href = '/subscription-expired';
              throw new Error('SUBSCRIPTION_EXPIRED');
            }
          } catch (e) {
            if (e.message === 'SUBSCRIPTION_EXPIRED') throw e;
          }
        }
        throw new Error(err402.message || 'Suscripción expirada');
      }

      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `Error ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error en API FormData request:', error);
    throw error;
  }
};

// Exportación nombrada para evitar warning de ESLint
const apiConfig = { API_URL, API_ENDPOINTS, apiRequest, apiRequestFormData };
export default apiConfig;